import { render, staticRenderFns } from "./BreadcrumbMenu.vue?vue&type=template&id=2ec5569e&scoped=true"
import script from "./BreadcrumbMenu.vue?vue&type=script&lang=js"
export * from "./BreadcrumbMenu.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbMenu.vue?vue&type=style&index=0&id=2ec5569e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5569e",
  null
  
)

export default component.exports